import * as React from 'react';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

interface HelpTooltipIconProps {
  message?: string;
  useSubTag?: boolean;
  width?: number;
  height?: number;
}

export function HelpTooltipIcon(props: HelpTooltipIconProps) {
  const { message, useSubTag = true, width = 18, height = 18 } = props;

  const icon = (
    <Tooltip title={message} enterTouchDelay={1} leaveTouchDelay={5000}>
      <IconButton
        disableFocusRipple
        disableRipple
        size="small"
        style={{ cursor: 'default', verticalAlign: 'text-top' }}
      >
        <HelpIcon style={{ width, height }} />
      </IconButton>
    </Tooltip>
  );

  return useSubTag ? <sub>{icon}</sub> : <>{icon}</>;
}
